<template>
	<div class="scrollable-x">
		<Table
			:columns="columns"
			:data-source="cnetList"
			:loading="isLoading"
		>
			<template #bodyCell="{ column, record }">
				<template v-if="column.dataIndex === 'id'">
					<router-link :to="{ name: 'cnet-constructor-edit', params: { id: record.id } }">
						#{{ record.id }}
					</router-link>
				</template>
				<template v-else-if="column.dataIndex === 'title'">
					<router-link :to="{ name: 'cnet-constructor-edit', params: { id: record.id } }">
						{{ record.title }}
					</router-link>
				</template>
				<template v-else-if="column.dataIndex === 'created'">
					<DateTimeDisplay :date="record.created" format="YYYY-MM-DD HH:mm" />
				</template>
				<template v-else-if="column.dataIndex === 'updated'">
					<DateTimeDisplay :date="record.updated" format="YYYY-MM-DD HH:mm" />
				</template>
				<template v-else-if="column.dataIndex === 'used_in_subnetworks'">
					<Space v-if="record.used_in_subnetworks && record.used_in_subnetworks.length > 0">
						<router-link
							v-for="subnetwork in record.used_in_subnetworks"
							:key="subnetwork.id"
							:to="{ name: 'settings-sub-network-edit', params: { id: 'sub-networks', subnetwork_id: subnetwork.id } }"
						>
							{{ subnetwork.label }}
						</router-link>
					</Space>
					<span v-else>—</span>
				</template>
				<template v-else-if="column.dataIndex === 'actions'">
					<Space>
						<Button @click="() => onApplyButtonClick(record.id)">
							{{ $t('cnet-constructor-list.table.buttons.apply') }}
						</Button>
						<PopconfirmButton
							v-if="!inModal"
							:title="$t('cnet-constructor-list.table.buttons.deleteConfirmation')"
							:ok-text="$t('cnet-constructor-list.table.buttons.delete')"
							:cancel-text="$t('common.cancelButtonLabel')"
							:onConfirm="() => onDeleteButtonClick(record.id)"
						>
							{{ $t('cnet-constructor-list.table.buttons.delete') }}
						</PopconfirmButton>
					</Space>
				</template>
			</template>
		</Table>
		<ApplyCNetModal
			v-model:visible="applyModalVisible"
			:forcedSubNetworkId="subNetworkId"
			:cNetConstructorSaveAndApply="cNetApply"
			:subGridCount="1"
			:saveEnabled="false"
		/>
	</div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { Button, Table, Space, message } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import Api from '@/api/Api';
import ApiCNet from '@/api/ApiCNet';
import Consts from '@/api/Consts';

import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import PopconfirmButton from '@/components/common/PopconfirmButton.vue';
import ApplyCNetModal from '@/components/map/cnetConstructorMode/ApplyCNetModal.vue';

import { showErrorMessage } from '@/components/common/errorMessage';


export default {
	components: {
		Button, Table, Space,
		DateTimeDisplay, PopconfirmButton, ApplyCNetModal,
	},
	props: {
		subNetworkId: {
			type: Number,
			default: 0,
		},
		// уведомляет, что надо обновить что-то вне таблицы
		onUpdate: {
			type: Function,
			default: () => {},
		},
	},
	setup(props) {
		const { t } = useI18n();
		const cnetList = ref([]);
		const isLoading = ref(true);
		const applyModalVisible = ref(false);
		const loadedCNetId = ref(null);

		const refreshList = () => {
			isLoading.value = true;
			ApiCNet.cNetListGetList(0, response => {
				if (response.status === 'ok') {
					cnetList.value = response.cnetList;
				} else {
					showErrorMessage(response.errors);
				}
				isLoading.value = false;
			});
		}

		onMounted(() => refreshList());

		const onDeleteButtonClick = (id) => {
			Api.cNetConstructorDelete(id, data => {
				if (data.status === 'ok') {
					message.success(t('cnet-constructor-list.table.messages.deleteSuccess'));
					refreshList();
				} else {
					showErrorMessage(data.errors);
				}
			});
		};

		const onApplyButtonClick = id => {
			loadedCNetId.value = id;
			applyModalVisible.value = true;
		};

		const cNetApply = (subNetworkId, cnetNumbers, cnetDates, doSave, onSuccess) => {
			// doSave not used
			Api.cNetConstructorApplyExisting(
				loadedCNetId.value,
				subNetworkId,
				cnetNumbers,
				cnetDates,
				data => {
					if (data.status === 'ok') {
						message.success(t('cnet-constructor.messages.saveSuccess'));
						onSuccess();
						refreshList();
						props.onUpdate();
						return;
					}
					showErrorMessage(data.errors);
				}
			);
		};

		const inModal = computed(() => props.subNetworkId > 0);

		return {
			cnetList,
			isLoading,
			inModal,
			columns: Consts.cnetListTableColumnsComp,
			onDeleteButtonClick,
			onApplyButtonClick,
			cNetApply,
			applyModalVisible,
			refreshList,
		};
	},
}
</script>
